<template>
    <div>
        <div class="mb-4 mt-2 px-10">
            <img class="mx-auto w-full rounded-2xl" :src="campaign.fullImageUrl" />
        </div>
        <div class="text-14 font-bold text-a-brown-502314 text-center mb-6" v-html="getname(campaign.detail)">
        </div>
        <div class="px-10">
            <RedButton @click="gotoDetail()">
                {{lbl.detail.view_detail}}
            </RedButton>
        </div>
    </div>
</template>
<script>
import RedButton from '@/components/Button/RedButton.vue'
import LocaleMixin from '@/mixin/LocaleMixin'
import Utility from '@/helper/Utility'

export default {
    name: 'NotificationTypeCampaign',
    mixins: [LocaleMixin],
    props: {
        campaign: {
            type: Object
        }
    },
    components: { RedButton },
    emits: [],
    data: function () { return {} },
    computed: {},
    created: function () { },
    mounted: function () { },
    methods: {

        gotoDetail: function () {
            this.$emit("onClose");
            this.$router.push("/notidetail/"+this.campaign.id);

        },
        getname: function (name) {
            return Utility.newLineToBr(name);
        }
    }
}
</script>
